import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { TranslateService } from '../../services/translate/translate.service';

import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { RegisterService } from '../../services/register/register.service';
import { DataLoginService } from '../../services/dataLogin/data-login.service';
import { AuthService } from '../../services/auth-service/auth.service';
import { IUserPkSk } from '../../interfaces/type-auth.interface';
import { Subscription } from 'rxjs';
import { MangoEventAnalyticsService } from '../../services/mango-events-analytics/mango-events-analytics.service';

interface TranslateData {
  title: string;
  messageReset: string;
  messageCheck: string;
  messageComplet: string;
  username: string;
  usernamePlaceholder: string;
  expire: string;
  newPassword: string;
  confirmPassword: string;
  passwordNotMatch: string;
  titleToast: string;
  contentToast: string;
  invalidCode: string;
  buttonCancek: string;
  buttonCheck: string;
  buttonresend: string;
  title2: string;
  buttonComplet: string;
  buttonSend: string;
}

@Component({
  selector: 'mg-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  params: any;
  config: any;
  isInvalidCode = false;

  url: string = '';
  tamWidth = 768;
  subscriptionTranslate!: Subscription;
  translate: TranslateData = {} as TranslateData;
  username: string = '';
  initValidUser: boolean = false;
  user: IUserPkSk = {} as IUserPkSk;
  typeResend: boolean = false;
  progress: 'validUser' | 'validCode' | 'reset' = 'validUser';
  password = '';
  confirmPassword = '';
  code = '';
  minutes: string = '00';
  seconds: string = '00';
  timeCode$!: any;
  token = '';
  initValidCode = false;
  isInvalidPassword = false;
  meesageError = '';
  constructor(
    private serviceDataLogin: DataLoginService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private auth: AuthService,
    private router: Router,
    private toastAlert: ToastrService,
    private mangoEventAnalyticsService: MangoEventAnalyticsService
  ) {
    this.tamWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.mangoEventAnalyticsService.sendEvent('forgot_password_page_view', {
      timestamp: new Date().toISOString(),
    });
    this.route.queryParamMap.subscribe((data: any) => {
      this.params = data.params;
    });
    const config = this.serviceDataLogin.configData;
    if (!config) {
      this.serviceDataLogin.configObservable.subscribe((config) => {
        this.config = config;
      });
    } else {
      this.config = config;
    }

    this.dataTranslate();
    this.url = this.serviceDataLogin.login().url || '';
  }
  validUsername() {
    this.initValidUser = true;
    this.meesageError = '';
    const isResend = this.progress === 'validCode';
    if (isResend) {
      this.mangoEventAnalyticsService.sendEvent('forgot_password_resend_code', {
        username: this.username,
        timestamp: new Date().toISOString(),
      });
    } else {
      this.mangoEventAnalyticsService.sendEvent('forgot_password_username_submit', {
        username: this.username,
        timestamp: new Date().toISOString(),
      });
    }
    this.auth.forgotPassword(this.url, this.username).subscribe(
      (resp: any) => {
        this.user = resp.user;
        const date = new Date(resp.timeExp);
        clearInterval(this.timeCode$);
        this.validationCodeTime(date);
        this.initValidUser = false;
        this.progress = 'validCode';
        if (isResend) {
          this.mangoEventAnalyticsService.sendEvent('forgot_password_code_resent', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
        } else {
          this.mangoEventAnalyticsService.sendEvent('forgot_password_code_sent', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
        }
      },
      (error) => {
        this.progress = 'validUser';
        this.mangoEventAnalyticsService.sendEvent('forgot_password_username_error', {
          username: this.username,
          error: error.error?.errorMessage || 'Internal server error',
          timestamp: new Date().toISOString(),
        });
        this.toastAlert.error(
          'Error',
          error.error.errorMessage || 'Internal server error'
        );
        this.initValidUser = false;
      }
    );
  }

  validationCodeTime(date = new Date()) {
    this.typeResend = false;
    const currentDate: Date = new Date();
    const timeDate = date.getTime() - currentDate.getTime();
    date = new Date(timeDate);
    this.timeCode$ = setInterval(() => {
      if (timeDate > 0) {
        this.minutes = this.padLeft(date.getMinutes() + '');
        this.seconds = this.padLeft(date.getSeconds() + '');
        date = new Date(date.getTime() - 1000);
      }
      if (this.minutes == '00' && this.seconds == '00') {
        this.typeResend = true;
        clearInterval(this.timeCode$);
      }
    }, 1000);
  }

  padLeft(time: string) {
    return '00'.substring(0, '00'.length - time.length) + time;
  }

  dataTranslate() {
    this.subscriptionTranslate = this.translateService
      .init('core')
      .subscribe((data) => {
        this.translate = data.login.modalResetPassword;
      });
  }

  authSms() {
    this.meesageError = '';
    this.initValidCode = true;
    this.isInvalidCode = false;
    this.mangoEventAnalyticsService.sendEvent('forgot_password_code_verify', {
      username: this.username,
      timestamp: new Date().toISOString(),
    });

    this.auth
      .verifySms(this.url, this.user?.pk || '', this.user?.sk || '', this.code)
      .subscribe(
        (resp: any) => {
          this.initValidCode = false;
          this.token = resp.jwtToken;
          this.isInvalidCode = false;
          this.progress = 'reset';
          this.mangoEventAnalyticsService.sendEvent('forgot_password_code_verified', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
        },
        (error) => {
          this.meesageError = '';
          this.progress = 'validCode';
          this.initValidCode = false;
          this.isInvalidCode = true;
          this.mangoEventAnalyticsService.sendEvent('forgot_password_code_invalid', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
        }
      );
  }
  back() {
    this.mangoEventAnalyticsService.sendEvent('forgot_password_back', {
      progress: this.progress,
      timestamp: new Date().toISOString(),
    });
    let queryParams: any = {};
    if (this.params) {
      queryParams = this.params;
    }
    this.router.navigate(['/login'], {
      queryParams,
    });
  }

  dataPassword(event: string) {
    this.password = event;
    if (this.confirmPassword.length > 0) {
      this.isInvalidPassword =
        this.password === this.confirmPassword ? false : true;
    }
  }

  dataConfirmPassword(event: string) {
    this.confirmPassword = event;
    this.isInvalidPassword =
      this.password === this.confirmPassword ? false : true;
  }
  complet() {
    this.mangoEventAnalyticsService.sendEvent('forgot_password_reset_attempt', {
      username: this.username,
      timestamp: new Date().toISOString(),
    });
    this.auth
      .resetPassword(
        this.url,
        this.password,
        this.token.length > 0 ? this.username : ''
      )
      .subscribe(
        (resp: any) => {
          this.mangoEventAnalyticsService.sendEvent('forgot_password_reset_success', {
            username: this.username,
            timestamp: new Date().toISOString(),
          });
          this.toastAlert.success(
            this.translate.titleToast,
            this.translate.contentToast
          );
          this.back();
        },
        (err) => {
          this.mangoEventAnalyticsService.sendEvent('forgot_password_reset_error', {
            username: this.username,
            error: err.error?.errorMessage || 'Unknown error',
            timestamp: new Date().toISOString(),
          });
          this.toastAlert.error(
            'Error reset password',
            err.error.errorMessage ||
              'There was an error changing the password, please try again'
          );
          this.back();
        }
      );
  }
  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.tamWidth = event.target.innerWidth;
  }
}
